import { render } from "./reLocation.vue?vue&type=template&id=058cb54a"
import script from "./reLocation.vue?vue&type=script&lang=js"
export * from "./reLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__